require("./extantCostDetails.scss");

// @ vendor
const React = require("react");
const PropTypes = require("prop-types");
const Immutable = require("immutable");
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
const BlockInfo = require("components/contactCenter/blockInfo/blockInfo");
const BrokerExAntSection = require("components/commons/brokerExAntSection/brokerExAntSection");
const { LoadingSection } = require('commonsComponents/loadingSection');
const BrokerDataItem = require("components/commons/brokerDataItem/brokerDataItem");
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @images
const privateIcon = require("assets/images/info-icon.svg");
const ccIcon = require('assets/images/icon-tutorial.svg');

// @helpers
const { getFormattedString,
    formatCurrency,
    formatWithoutRound,
    formatPercentage
} = require("utilities/currencyHelper");

// @constants
const {
  POTENTIAL_SELL_FUNDS_COSTS,
  POTENTIAL_COST,
  POTENTIAL_COST_TYPE,
} = require('constants/index');

class ExtantCostDetails extends React.Component {
    constructor(props) {
        super(props);

        this.buildDetails = this.buildDetails.bind(this);
        this.buildLeftColumn = this.buildLeftColumn.bind(this);
        this.buildRightColumn = this.buildRightColumn.bind(this);
    }

    buildLeftColumn() {
        const { immContributionFunds, immAccount } = this.props;
        const fundName = immContributionFunds.getIn(['steps', 0, 'contributionFunds', 'name']);
        const periodicityLabel = immContributionFunds.getIn(['steps', 0, 'periodicityLabel']);
        const currencyObject = Immutable.Map().merge({
            amount: immContributionFunds.getIn(["steps", 0, "amount"]),
            currency: immAccount.getIn(["balance", "currency"]),
        });
        const amountInvestment = getFormattedString(currencyObject);
        const contractNumber = immAccount.get("contractNumber");
        const owner = immAccount.get("accountHolder") || "";
        const acountCodbban = immAccount.getIn([
            "ibanComplex",
            "codbban",
        ]);
        const accountBalanceObject = Immutable.Map().merge({
            amount: immAccount.getIn(["balance", "amount"]),
            currency: immAccount.getIn(["balance", "currency"]),
        })
        const accountBalance = getFormattedString(accountBalanceObject);
        const accountLabel = `${immAccount.get(
            "alias"
        )} ...${acountCodbban.substring(
            acountCodbban.length - 5,
            acountCodbban.length - 1
        )} (Saldo: ${accountBalance})`;
        return (
            <div className="contribution-fund-description__left-column-container">
                <div className="contribution-fund-description__column-title">
                    <FormattedText value="brokerContributionFundStep2-orderDataTitle" />
                </div>
                <BrokerDataItem
                    label="brokerContributionFundStep2-fundToBuy"
                    data={fundName}
                />
                <BrokerDataItem
                    label="brokerContributionFundStep2-estimatedAmount"
                    data={`${amountInvestment} ${periodicityLabel}`}
                    eventCategory="contribucion periodica/paso 2"
                    eventTag={formatText(
                        "brokerContributionFundStep2-orderData_estimatedAmount_eventTag"
                    )}
                    complexTooltip
                />
                <BrokerDataItem
                    label="brokerContributionFundStep2-extantCost_contract"
                    data={contractNumber}
                />
                <BrokerDataItem
                    label="brokerContributionFundStep2-extantCost_first_holder"
                    data={owner}
                />
                <BrokerDataItem
                    label="brokerContributionFundStep2-extantCost_associated_account"
                    data={accountLabel}
                />
            </div>
        );
    }

    buildRightColumn() {
        const { immContributionFunds } = this.props;
        const dataExAnt = immContributionFunds.getIn(['fetchDataExt', 'response']);
        const periodicityLabel = immContributionFunds.getIn(['steps', 0, 'periodicityLabel']);
        const periodicityLabelMinus = periodicityLabel.toLowerCase();
        let data, potentialSellCosts, potentialSellCostsText;
        if (immContributionFunds.get('fetchingDataExt')) {
            data = <LoadingSection />;
        } else if (dataExAnt) {
            data = dataExAnt.map((item, index) => (
                item.get('type')  !== POTENTIAL_COST &&
                (
                    <BrokerExAntSection
                        context="brokerContributionFundStep2"
                        eventCategory="orden compra fondos/paso 2"
                        section={item}
                        key={index}
                        complexTooltip={true}
                    />
                )
            ));

            potentialSellCosts  = dataExAnt.find(
                (item) => item.get('type') === POTENTIAL_COST
            );

        } else if (immContributionFunds.get('isFetchedPre') === false) {
            data = <LoadingSection />
        }

        if (potentialSellCosts && potentialSellCosts.get('type') === POTENTIAL_COST) {
            const dataPotentialCosts = potentialSellCosts.get('details').toJS()[0];
            const currency = formatCurrency(dataPotentialCosts.currency ? dataPotentialCosts.currency : 'EUR');
            const amount = formatWithoutRound(dataPotentialCosts.amount, 2);
            const immPercentage = formatPercentage(dataPotentialCosts.percentage, 2);
            const formatAmount = `${amount} ${currency}`
 
            const stylesForText = __CONTACT_CENTER__
              ? 'broker-ex-ant-cost__section-cc'
              : 'broker-ex-ant-cost__section';
            potentialSellCostsText = (
            <div>
                <br></br>
                <div className={stylesForText}>
                    <FormattedText value="brokerContributionFundStep2-potencialSellCost"
                    injectedStrings={[formatAmount, immPercentage]} />
                </div>
                <div className="broker-ex-ant-cost__section-total-separator" />
                <br></br>
                <div className={stylesForText}>
                    <FormattedText value="brokerContributionFundStep2-costExplanation" />
                </div>
            </div>   
            );
        }

        const immContributionCost = dataExAnt?.find(
            (item) => item.get('descriptionKey') === 'recurringTransferCosts'
        );
        const estimatedContributionCostAmount = formatWithoutRound(immContributionCost?.getIn(['total', 'amount']), 2) || 0;
        const estimatedContributionCostCurrency = formatCurrency(immContributionCost?.getIn(['total', 'currency']) || 'EUR');
        const estimatedContributionCost = `${estimatedContributionCostAmount} ${estimatedContributionCostCurrency}`;
        return (
            <div className="contribution-fund-description__right-column-container">
                {data}
                <div>
                    <FormattedText value="brokerContributionFundStep2-contributionCost"
                        injectedStrings={[periodicityLabelMinus, estimatedContributionCost]}
                    />
                    <br></br>
                    {potentialSellCostsText}
                </div>
            </div>
        );
    }

    buildDetails(title, footer = null) {
        return (
            <React.Fragment>
                <div className="contribution-fund-description__title-description">
                    {title}
                </div>
                {this.buildLeftColumn()}
                {this.buildRightColumn()}
                <span className="contribution-fund-description__footer">
                    {footer}
                </span>
            </React.Fragment>
        );
    }

    renderExtantDataWeb() {
        const { immContributionFunds } = this.props;
        const dataExAnt = immContributionFunds.getIn(['fetchDataExt', 'response']);
        const potentialSellCostFunds  = dataExAnt && dataExAnt.find(
            (item) => item.get("descriptionKey") === POTENTIAL_SELL_FUNDS_COSTS
        );

        return (
            <div className="contribution-fund-description__web-wrapper">
                {this.buildLeftColumn()}
                {this.buildRightColumn()}
                {potentialSellCostFunds && potentialSellCostFunds.get('type') === POTENTIAL_COST_TYPE &&
                    <span className="contribution-fund-description__footer">
                        <FormattedText
                            value="brokerContributionFundStep2-extantCost_footer_description"
                        />
                    </span>
                }
            </div>
        );
    }

    render() {
        return __CONTACT_CENTER__ ? (
            <BlockInfo extraClass="contribution-fund-description__block-info">
                {this.buildDetails(
                    formatText('brokerContributionFundStep2-extantCost_description_cc'),
                    formatText('brokerContributionFundStep2-extantCost_footer_description_cc')
                )}
            </BlockInfo>
        ) : (
            <div>
                {this.renderExtantDataWeb()}
            </div>
        );
    }
}

ExtantCostDetails.propTypes = {
    immContributionFunds: PropTypes.object.isRequired,
    immAccount: PropTypes.object.isRequired,
    immBrokerETFsProduct: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
};

module.exports.constructor = ExtantCostDetails;

export default ExtantCostDetails;
